import React from 'react';
import { Box } from 'vindi-ds-components';

import {
  PrBarChart,
  PrPieChart,
  PrDollarSign,
} from 'vindi-ds-icons/pr';

import ReportCard from './reportCard';
import templates from '../template/templates.json';

const multiReportParams = [
  {
    icon: <PrBarChart />,
    name: templates.bills.name,
    links: templates.bills.links,
  },
  {
    icon: <PrPieChart />,
    name: templates.charges.name,
    links: templates.charges.links,
  },
  {
    icon: <PrDollarSign />,
    name: templates.transactions.name,
    links: templates.transactions.links,
  },
];

function MultiLinkReports() {
  return (
    <Box>
      {multiReportParams.map((multiReport) => (
        <ReportCard
          key={multiReport.name}
          icon={multiReport.icon}
          name={multiReport.name}
          links={multiReport.links}
          marginCard={4}
          heightCard={multiReport.links.length > 2 ? '13.5em' : '10em'}
        />
      ))}
    </Box>
  );
}

export default MultiLinkReports;
